<!-- A talk with two versions (VIZBI 2016, decision S1, 2026-10-21): With slides (at first) or
     Speaker only, as two toggle chips under the title (fullstack/claude/FORMS.md § Toggle chips).
     The video page swaps the player and carries on from the same second. -->
<template>
  <div class="versions" role="group" aria-label="Version of this talk">
    <button
      v-for="version in VERSIONS"
      :key="version.label"
      type="button"
      class="chip"
      :class="{isChosen: getIsChosen(version)}"
      :aria-pressed="getIsChosen(version)"
      @click="emit('update:isSpeakerOnly', version.isSpeakerOnly)">
      <span class="disc" aria-hidden="true">{{ getIsChosen(version) ? "✓" : "" }}</span>
      {{ version.label }}
    </button>
  </div>
</template>

<script setup>
const props = defineProps({isSpeakerOnly: {type: Boolean, default: false}});
const emit = defineEmits(["update:isSpeakerOnly"]);
const getIsChosen = (version) => version.isSpeakerOnly === props.isSpeakerOnly;
const VERSIONS = [
  {label: "With slides", isSpeakerOnly: false},
  {label: "Speaker only", isSpeakerOnly: true}
];
</script>

<style scoped>
.versions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 6px 0 10px;
}
/* global.css styles every <button>: reset it, then draw the chip */
.chip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 4px 14px 4px 6px;
  border: 1.5px solid var(--brand-color);
  border-radius: 999px;
  box-shadow: none;
  background: var(--background-color);
  color: var(--text-color);
  font: inherit;
  font-size: 0.95rem;
  font-weight: 500;
  opacity: 0.78;
  cursor: pointer;
}
.chip.isChosen {
  background: color-mix(in srgb, var(--brand-color) 15%, var(--background-color));
  font-weight: 600;
  opacity: 1;
}
.disc {
  display: grid;
  place-items: center;
  width: 18px;
  height: 18px;
  border: 1.5px solid var(--brand-color);
  border-radius: 50%;
  background: var(--background-color);
  color: var(--brand-color);
  font-size: 12px;
}
</style>
